import PropTypes from "prop-types";
import { useEffect } from "react";
// @arco
import { Drawer, Layout } from "@arco-design/web-react";
// hooks
// routes
import { usePathname } from "src/routes/hook";
// project config
import NavList from "src/components/nav-section/vertical/nav-list";
import { useResponsive } from "src/hooks/use-responsive";
import Image from "src/components/image";
import { NAV } from "../config-layout";

// ----------------------------------------------------------------------

NavVertical.propTypes = {
    onCloseNav: PropTypes.func,
    openNav: PropTypes.bool,
};

export default function NavVertical({ openNav, onCloseNav }) {
    const pathname = usePathname();
    const lgUp = useResponsive("up", "lg");


    useEffect(() => {
        if (openNav) {
            if (onCloseNav) onCloseNav();
        }
    }, [pathname]);

    return (
        <>
            {lgUp ? (
                <Layout.Sider
                    width={NAV.W_VERTICAL}
                    style={{
                        position: 'sticky',
                        top: 60,
                        height: 'calc(100vh - 60px)',
                        overflow: 'auto',
                    }}
                >
                    <NavList />
                </Layout.Sider>
            ) : (
                <Drawer
                    width={NAV.W_VERTICAL}
                    placement="left"
                    closable={false}
                    title={null}
                    visible={openNav}
                    footer={null}
                    onCancel={onCloseNav}
                >
                    <>
                        <div size={12} style={{ display: 'inline-flex', alignItems: 'center', height: 40, gap: 12 }}>
                            <Image src="/assets/icon/auth/ic_full_logo.svg" alt="HIHISHIP" style={{ height: 30, display: 'block' }} />
                        </div>
                        <NavList />
                    </>
                </Drawer>
            )}
        </>
    );
}
